import { Button, Modal } from "react-bootstrap";

function SendDocViaEmailModal({ isOpen, handleClose, setEmail, email, docId, handleEmail }) {
  return (
    <Modal
      show={isOpen}
      onHide={handleClose}
      centered
      style={{
        // zIndex: 1050,
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0, 0, 255, 0.1)",
      }}
    >
      <Modal.Header
        style={{
          borderBottom: "0px",
        }}
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
      >
        <Modal.Title
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          id="modal_title"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          Send Document via Email
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="document-modal-body m-2 mt-2">
        <div className="d-flex w-100">
          <div className="col-5 p-0">Send Document via Email</div>
          <div className="col-7 p-0">
            <input
              type="email"
              placeholder="Enter recipient's email"
              className="form-control py-0 height-25"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
      </Modal.Body>
      <div className="d-flex align-items-center justify-content-between py-0 px-1 p-b-5">
        <Button variant="secondary" onClick={handleClose} className="btn py-0 height-25">
          Close
        </Button>
        <Button
          variant="success"
          onClick={() => handleEmail(docId, email)}
          className="btn py-0 height-25"
        >
          Send
        </Button>
      </div>
    </Modal>
  );
}

export default SendDocViaEmailModal;
